<template lang="pug">
  ul.options.m-top-1.absolute
    router-link.row.middle.hidden.option.text-normal.black.width-100(
      :to='{name: routes.kreaCreateEducationalContent, query: {contentId: program.id, setting: "language"}}'
    )
      simple-svg.black-icon.m-right-05(:filepath='getOptionIcon("addLanguage")' width='18px' height='18px')
      | {{ $t("programCard.options.addLanguage") }}
    button.row.start.option.text-normal.black.width-100(
      v-if='draft'
      :disabled='isTrial'
      @click='showAddCollaboratorsModal'
    )
      simple-svg.black-icon.m-right-05(:filepath='getOptionIcon("addCollaborators")' width='21px' height='21px')
      | {{ $t("programCard.options.addCollaborators") }}
    router-link.row.middle.option.text-normal.black.width-100(
      :to='{name: routes.kreaCreateEducationalContent, query: {contentId: program.id, setting: "contentType"}}'
    )
      simple-svg.black-icon.m-right-05(:filepath='getOptionIcon("changeContentType")' width='18px' height='18px')
      | {{ $t("programCard.options.changeContentType") }}
    button.row.start.option.text-normal.black.width-100(
      v-if='!draft'
      :disabled='isTrial'
      @click='showUnpublishContentModal'
    )
      simple-svg.black-icon.m-right-05(:filepath='getOptionIcon("unpublish")' width='18px' height='18px')
      | {{ $t("programCard.options.unpublish") }}
    button.row.start.option.text-normal.black.width-100(
      v-else
      :disabled='isTrial'
      @click='showPublishContentModal'
    )
      simple-svg.black-icon.m-right-05(:filepath='getOptionIcon("publish")' width='18px' height='18px')
      | {{ $t("programCard.options.publish") }}
    button.row.start.option.text-normal.black.width-100(
      v-if='!draft'
      :disabled='isTrial'
      @click='showEditKeywordsModal'
    )
      simple-svg.black-icon.m-right-05(:filepath='getOptionIcon("editKeywords")' width='18px' height='18px')
      | {{ $t("programCard.options.editKeywords") }}
    button.row.start.option.text-normal.black.width-100(
      :disabled='isTrial || !isOwner'
      @click='showDeleteContentModal'
    )
      simple-svg.black-icon.m-right-05(:filepath='getOptionIcon("delete")' width='18px' height='18px')
      | {{ $t("programCard.options.delete") }}
</template>

<script>
import { mapActions } from 'vuex'
import { programCardOptions } from '../../constants/krea'
import { routes } from '../../router'

export default {
  props: {
    draft: { type: Boolean },
    isTrial: { type: Boolean },
    isOwner: { type: Boolean },
    program: { type: Object },
    approvedLanguages: { type: Array },
    disapprovedLanguages: { type: Array },
    availableLanguages: { type: Array }
  },
  data() {
    return {
      routes
    }
  },
  methods: {
    ...mapActions([
      'showElement'
    ]),
    getOptionIcon(option) {
      return programCardOptions.find(op => op.label === option).icon
    },
    showAddCollaboratorsModal() {
      this.showElement({
        element: 'kreaCreateInTeamModal',
        props: { contentId: this.program.id }
      })
    },
    showPublishContentModal() {
      this.showElement({
        element: 'kreaPublishContentModal',
        props: {
          contentId: this.program.id,
          keywords: this.program.keywords,
          languages: this.disapprovedLanguages,
          completeness: this.program.completeness
        }
      })
    },
    showDeleteContentModal() {
      this.showElement({
        element: 'kreaDeleteModal',
        props: {
          id: this.program.id,
          languages: this.availableLanguages,
          type: 'content'
        }
      })
    },
    showUnpublishContentModal() {
      this.showElement({
        element: 'kreaUnpublishContentModal',
        props: {
          contentId: this.program.id,
          contentTitle: this.program.title,
          languages: this.approvedLanguages
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';

.options{
  z-index: 2;
  width: 227px;
  right: 12px;
  top: 40px;
  background-color: $white;
  border: 1px solid $light-gray;
  border-radius: 5px;
  box-shadow: 0px 2px 2px 0px #73798540;

  &>:first-child{
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
  }
  &>:last-child{
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
  }
  .option{
    padding: 8px;
    cursor: pointer;
    &:hover{
      background-color: $light-gray;
    }
    &:disabled{
      cursor: not-allowed;
      opacity: 0.7
    }
  }
}
</style>
